import {ToolExecuteParams} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {z} from 'zod';
import setCardInState from '../../utils/cardStateStorage/setCardInState';
import getCardFromState from '../../utils/cardStateStorage/getCardFromState';
import {DateTime} from 'luxon';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';
import {conditionOutputSchema} from '../../promptToCardAgentV2.types';

const editConditionOutputToolSchema = z.object({
  outputId: z.number().describe('The id of the output to update'),
  conditionOutput: conditionOutputSchema.extend({
    name: z.string().describe('The name of the output'),
  }),
});

export default function editConditionOutputTool() {
  async function execute(params: ToolExecuteParams<typeof editConditionOutputToolSchema>) {
    const {outputId, conditionOutput} = params.input;

    const currentCard = getCardFromState();
    const currentOutput = currentCard.outputs.find((output) => output.id === outputId);

    if (!currentOutput) {
      return toolResult(
        `Condition output ID ${outputId} was not found for card ID ${currentCard.id}.`,
      );
    }

    currentOutput.name = conditionOutput.name;

    if (conditionOutput.textValues) currentOutput.textValues = conditionOutput.textValues;
    if (conditionOutput.numericValues) currentOutput.numericValues = conditionOutput.numericValues;
    if (conditionOutput.booleanValue) currentOutput.booleanValue = conditionOutput.booleanValue;
    if (conditionOutput.dateValues)
      currentOutput.dateValues = conditionOutput.dateValues.map((date) => DateTime.fromISO(date));
    if (conditionOutput.datesRange)
      currentOutput.datesRange = {
        from: DateTime.fromISO(conditionOutput.datesRange.from),
        to: DateTime.fromISO(conditionOutput.datesRange.to),
      };
    if (conditionOutput.numbersRange)
      currentOutput.numbersRange = {
        from: conditionOutput.numbersRange.from,
        to: conditionOutput.numbersRange.to,
      };

    setCardInState(currentCard);

    return toolResult('Condition output updated');
  }

  return tool({
    name: V2CardAgentToolName.UpdateConditionOutput,
    displayName: 'Updating condition output',
    description: 'Update a condition output in an existing condition card',
    inputSchema: editConditionOutputToolSchema,
    execute,
  });
}
